import { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Icon, IconButton, Tooltip } from '@material-ui/core';
import { BsFiletypeJson, BsFiletypeXls } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';

export default function CopyPasteButtonCluster(props) {
    const [copyConfirm, setCopyConfirm] = useState(false);
    const [pasteConfirm, setPasteConfirm] = useState(false);

    const { t } = useTranslation(['common']);

    return (
        <div className='flex'>
            <div className={'relative flex items-center justify-center ' + (copyConfirm ? 'z-10' : '')}>

                <div className={'transition-opacity ' + (copyConfirm ? 'opacity-50' : '')}>
                    <Tooltip title={t('to_clipboard')}>
                        <IconButton onClick={() => setCopyConfirm(true)}>
                            <Icon>content_copy</Icon>
                        </IconButton>
                    </Tooltip>
                </div>

                <div className={'absolute flex gap-8 items-center justify-center transition-transform transform bg-white bg-opacity-90 border rounded-full p-4 shadow-xl  ' + (copyConfirm ? 'scale-100' : 'scale-0')}>

                    <button className='w-32 h-32 rounded-full bg-black text-white flex items-center justify-center' onClick={() => { props.onCopyJson(); setCopyConfirm(false);/*methods.handleSubmit(handleJsonCopy)*/ }}>
                        <BsFiletypeJson className='text-lg' />
                    </button>

                    <button className='w-32 h-32 rounded-full bg-black text-white flex items-center justify-center' onClick={() => { props.onCopyXls(); setCopyConfirm(false);/*methods.handleSubmit(handleXlsCopy)*/ }}>
                        <BsFiletypeXls className='text-lg' />
                    </button>

                    <button className='w-32 h-32 rounded-full bg-black text-white flex items-center justify-center' onClick={() => setCopyConfirm(false)}>
                        <Icon fontSize='small'>clear</Icon>
                    </button>

                </div>

            </div>

            <div className={'relative flex items-center justify-center ' + (pasteConfirm ? 'z-10' : '')}>

                <div className={'transform transition-transform  ' + (pasteConfirm ? 'scale-50' : 'scale-100')}>
                    <Tooltip title={t('from_clipboard')}>
                        <IconButton onClick={() => setPasteConfirm(true)}>
                            <Icon>content_paste_go_icon</Icon>
                        </IconButton>
                    </Tooltip>
                </div>

                <div className={'absolute flex gap-8 items-center justify-center transition-transform transform bg-white bg-opacity-90 border rounded-full p-4 shadow-xl  ' + (pasteConfirm ? 'scale-100' : 'scale-0')}>

                    <button className='w-32 h-32 rounded-full bg-black text-white flex items-center justify-center' onClick={() => { props.onPaste(); setPasteConfirm(false); }}>
                        <Icon fontSize='small'>check</Icon>
                    </button>

                    <button className='w-32 h-32 rounded-full bg-black text-white flex items-center justify-center' onClick={() => setPasteConfirm(false)}>
                        <Icon fontSize='small'>clear</Icon>
                    </button>

                </div>

            </div>
        </div>
    );
}